<ng-content></ng-content>
<div class="ml-auto flex flex-row self-start empty:hidden">
  <ng-content select="[sb-dialog-header-actions], sb-dialog-header-actions, [sbDialogHeaderActions]"></ng-content>
  @if (showClose) {
    <button class="self-start" sb-icon-button [color]="'transparent'" [size]="'base'" sb-dialog-close>
      <sb-icon [name]="'times'"></sb-icon>
      <span class="sr-only">{{ 'Close' | translate }}</span>
    </button>
  }
</div>
